import { FormProvider } from 'react-hook-form';
import { FormInput } from '@/components/form/form-input';
import { SmartSuggestionFormShell } from '@/features/inventory/pages/smart-suggestion/form-shell';
import { useAgeGroupPresetForm } from '../../hooks/price-preset-hooks';
import { amountInputProps } from '../price-presets/amount-input-props';

const AgeGroupPresetForm = () => {
  const { id, form, isLoading, isSaving, handleReset, handleDelete, onSubmit } =
    useAgeGroupPresetForm();

  return (
    <div className="space-y-6">
      <FormProvider {...form}>
        <SmartSuggestionFormShell
          id={id}
          title={id ? 'Edit Age Group' : 'New Age Group'}
          description="Default Amount is pre-filled when the age group is added to an activity: per person, minus for a discount (-5), plain for a surcharge (3). Order sets where it appears in the picker."
          isLoading={isLoading}
          isSaving={isSaving}
          onSubmit={form.handleSubmit(onSubmit)}
          onReset={handleReset}
          onDelete={handleDelete}
        >
          <FormInput
            name="label"
            label="Age Group"
            placeholder="e.g. Child (4-11)"
            required
          />
          <FormInput
            name="defaultAmount"
            label="Default Amount"
            {...amountInputProps}
          />
          <FormInput
            name="order"
            label="Order"
            type="number"
            min={1}
            step={1}
            placeholder="After the last one"
            optional
          />
        </SmartSuggestionFormShell>
      </FormProvider>
    </div>
  );
};

export default AgeGroupPresetForm;
